module.exports = __webpack_public_path__ + "assets/nike-intro-ab170f.mp4";